<!-- Выбирает заказ-наряд ремонта для привязки к расходу. -->
<template>
  <BaseSelect
    :options="formattedOptions"
    :model-value="modelValue"
    :placeholder="placeholder"
    :searchable="true"
    :clearable="clearable"
    :external-search="true"
    no-results-text="Ремонт не найден"
    @update:model-value="handleUpdate"
    @change="handleChange"
    @search="handleSearch"
    @clear-search="handleClearSearch"
  />
</template>

<script>
import { formatDate } from "@/utils/dateUtils";
import { formatBigNumber } from "@/utils/numberUtils";

import { useFleetRepairStore } from "@/stores/fleetRepairStore";

export default {
  name: "FleetRepairSelect",

  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: "Выберите ремонт",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["update:modelValue", "change"],

  data() {
    return {
      preselectedOption: null,
      isSearchActive: false,
    };
  },

  computed: {
    repairStore() {
      return useFleetRepairStore();
    },

    formattedOptions() {
      const options = this.repairStore.repairSelectItems.map((repair) =>
        this.formatRepairOption(repair)
      );

      if (
        this.preselectedOption &&
        !this.isSearchActive &&
        !options.find(
          (option) =>
            String(option.value) === String(this.preselectedOption.value)
        )
      ) {
        return [this.preselectedOption, ...options];
      }

      return options;
    },
  },

  watch: {
    async modelValue(newValue, oldValue) {
      if (!newValue) {
        this.preselectedOption = null;
        return;
      }

      if (newValue === oldValue) return;

      if (!this.isSearchActive && !this.preselectedOption) {
        await this.fetchPreselectedOption();
      }
    },
  },

  methods: {
    handleUpdate(value) {
      if (!value) {
        this.preselectedOption = null;
      }

      this.$emit("update:modelValue", value);
    },

    handleChange(option) {
      this.preselectedOption = option
        ? { value: option.value, label: option.label }
        : null;

      this.$emit("change", option ? option.value : null);
    },

    async handleSearch(searchData) {
      this.isSearchActive = true;
      await this.fetchRepairs({ "q[search]": searchData.query });
    },

    async handleClearSearch() {
      this.isSearchActive = false;
      await this.fetchRepairs();
    },

    async fetchRepairs(params = {}) {
      await this.repairStore.fetchRepairSelectItems(params);
    },

    async fetchPreselectedOption() {
      if (!this.modelValue) return;

      const exists = this.repairStore.repairSelectItems.find(
        (repair) => String(repair.id) === String(this.modelValue)
      );
      if (exists) return;

      const repair = await this.repairStore.fetchRepairSelectItem(
        this.modelValue
      );
      this.preselectedOption = this.formatRepairOption(repair);
    },

    formatRepairOption(repair) {
      const title = repair.title || `Ремонт #${repair.id}`;
      const parts = [
        title,
        formatDate(repair.performed_at),
        repair.vehicle?.full_name,
        `${formatBigNumber(repair.total_amount)} ₽`,
      ].filter(Boolean);

      return {
        value: repair.id,
        label: parts.join(" · "),
      };
    },
  },

  async mounted() {
    await this.fetchRepairs();
    await this.fetchPreselectedOption();
  },
};
</script>
